import { render, staticRenderFns } from "./imgItem.vue?vue&type=template&id=601acd06&scoped=true&"
import script from "./imgItem.vue?vue&type=script&lang=js&"
export * from "./imgItem.vue?vue&type=script&lang=js&"
import style0 from "./imgItem.vue?vue&type=style&index=0&id=601acd06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601acd06",
  null
  
)

export default component.exports